/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import Head from 'next/head';
import MeuFinanciamentoBanner from '@/components/organisms/MeuFinanciamentoBanner/MeuFinanciamentoBanner';
import MeuFinanciamentoServicos from '@/components/organisms/MeuFinanciamentoServicos/MeuFinanciamentoServicos';
import MeuFinanciamentoParcelas from '@/components/organisms/MeuFinanciamentoParcelas';
import MeuFinanciamentoDebito from '@/components/organisms/MeuFinanciamentoDebito';
import MeuFinanciamentoImobiliario from '@/components/organisms/MeuFinanciamentoImobiliario';
import MeuFinanciamentoConsulte from '@/components/organisms/MeuFinanciamentoConsulte';
import Header24 from '@/components/organisms/Header24';
import Footer24 from '@/components/organisms/Footer24';
import Styles from './MeuFinanciamento.css';

function MeuFinanciamento() {
  return (
    <>
      <Head>
        <title>Consultar Financiamento | Santander Financiamentos</title>
        <meta
          name="Description"
          content="Gerencie seu financiamento Santander com segurança. Antecipe parcelas, consulte serviços, emita boletos e aproveite nossas vantagens exclusivas pelo WhatsApp!"
        />
        <link
          rel="canonical"
          href="https://www.santander.com.br/hotsite/santanderfinanciamentos/consultar-financiamento.html"
        />
        <meta name="robots" content="index, follow" />
        <meta
          name="keywords"
          content="consultar meu financiamento, negociação de dívidas, consultar meu financiamento online, segunda via de boleto, atendimento digital, serviços digitais, atendimento via WhatsApp, contrato de financiamento, financiamento online, antecipar parcelas, consulta de financiamento, suporte financeiro, autoatendimento Santander financiamentos, canal digital, pagamento de parcelas, renegociação de parcelas"
        />
        {/* <!-- OPEN GRAPH TAGS FOR FACEBOOK, WHATSAPP AND LINKEDIN --> */}
        <meta property="og:locale" content="pt_BR" />
        <meta property="og:title" content="Consultar Financiamento | Santander Financiamentos  " />
        <meta
          property="og:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/consultar-financiamento.html"
        />
        <meta property="og:site_name" content="Santander Financiamentos" />
        <meta
          property="og:description"
          content="Gerencie seu financiamento Santander com segurança. Antecipe parcelas, consulte serviços, emita boletos e aproveite nossas vantagens exclusivas pelo WhatsApp!"
        />
        <meta
          property="og:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/meu-financiamento/banner-hero.webp"
        />
        <meta
          property="og:image:alt"
          content="Mulher de cabelos longos e blusa vermelha xadrez observando seu financiamento no portal do cliente da Santander Financiamentos"
        />
        <meta property="og:image:type" content="image/webp" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="627" />
        <meta property="og:type" content="website" />

        {/* <!-- TWITTER CARDS FOR TWITTER --> */}
        <meta name="twitter:card" content="" />
        <meta name="twitter:title" content="Consultar Financiamento | Santander Financiamentos " />
        <meta
          name="twitter:description"
          content="Gerencie seu financiamento Santander com segurança. Antecipe parcelas, consulte serviços, emita boletos e aproveite nossas vantagens exclusivas pelo WhatsApp!"
        />
        <meta
          name="twitter:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/consultar-financiamento.html"
        />
        <meta
          property="twitter:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/meu-financiamento/banner-hero.webp"
        />
        <meta
          property="twitter:image:alt"
          content="Mulher de cabelos longos e blusa vermelha xadrez observando seu financiamento no portal do cliente da Santander Financiamentos"
        />
        <meta property="twitter:image:type" content="image/webp" />
        <meta property="twitter:image:width" content="1200" />
        <meta property="twitter:image:height" content="627" />
      </Head>
      <Header24 isHome24 />
      <MeuFinanciamentoBanner />
      <MeuFinanciamentoServicos />
      <MeuFinanciamentoParcelas />
      <MeuFinanciamentoDebito />
      <MeuFinanciamentoImobiliario />
      <MeuFinanciamentoConsulte />
      <Footer24 />
      <style jsx>{Styles}</style>
    </>
  );
}

export default MeuFinanciamento;
